






















import { Component, Prop, Vue } from 'vue-property-decorator';
import { ListingDetail } from '@/models/ListingDetail';
import { Loader } from '@googlemaps/js-api-loader';

@Component
export default class GoogleMapPanel extends Vue {

    public tab: string = 'streetview';
    public isMapLoaded: boolean = false;

    get config() {
        return this.$store.state.config;
    }

    get selectedListingDetail(): ListingDetail {
        return this.$store.state.listings.selectedListingDetail;
    }

    get apiKey(): string {
        return this.config.gMapAPIKey;
    }

    get googleMarkerUrl(): string {
        return this.config.googleMarkerUrl;
    }

    public mounted() {
        this.initStreetView();
    }

    public initStreetView() {
        const loader = new Loader({
            apiKey: this.apiKey,
        });

        loader.load().then(() => {
            const listingPosition = new google.maps.LatLng(this.selectedListingDetail.Latitude, this.selectedListingDetail.Longitude);

            const panoOptions = {
                position: listingPosition,
                panControl: false,
                addressControl: false,
                linksControl: false,
            };
            const googleStreet = new google.maps.StreetViewPanorama(document.getElementById('street-view-map') as Element, panoOptions);
            const googleStreetViewService = new google.maps.StreetViewService();
            const googleNameSpace = google;
            googleStreetViewService.getPanorama({
                location: listingPosition,
                preference: google.maps.StreetViewPreference.NEAREST,
                radius: 50,
                },
                (panoData: any, status: any) => {
                    if (panoData != null) {
                        const panoCenter = panoData.location.latLng;
                        const heading = google.maps.geometry.spherical.computeHeading(panoCenter, listingPosition);
                        const pov = googleStreet.getPov();
                        pov.heading = heading;
                        googleStreet.setPosition(panoCenter);
                        googleStreet.setPov(pov);
                }
            });
        });
    }

    public onClickMapTab() {
        if (!this.isMapLoaded) {
            this.$nextTick( () => {
                const loader = new Loader({
                    apiKey: this.apiKey,
                });

                loader.load().then(() => {
                    const listingPosition = new google.maps.LatLng(this.selectedListingDetail.Latitude, this.selectedListingDetail.Longitude);

                    const mapOptions = {
                        center: listingPosition,
                        zoom: 16,
                    };
                    const mapContainer = new google.maps.Map(document.getElementById('google-map') as Element, mapOptions);

                    const googleMarker = new google.maps.Marker({
                        position: listingPosition,
                        icon: this.googleMarkerUrl,
                        map: mapContainer,
                    });
                    this.isMapLoaded = true;
                }).catch( (e) => {
                    console.log(e);
                });
            });
        }
    }
}

